import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import MetricsSelectorContainer
  from './../Containers/MetricsSelectorContainer';
import MetricsJobInfoContainer
  from './../Containers/MetricsJobInfoContainer';
import PerformanceMetricsDurationChartContainer
  from './../Containers/PerformanceMetricsDurationChartContainer';
import PerformanceDeltasContainer
  from './../Containers/PerformanceDeltasContainer';
import PerformanceTypeSelectorContainer
  from './../Containers/PerformanceTypeSelectorContainer';
import RegressionTestsPerformanceSelectorContainer
  from './../Containers/RegressionTestsPerformanceSelectorContainer';
import ViewScenarioStatusContainer
  from './../Containers/ViewScenarioStatusContainer';
import { pageTypes } from './../helpers';

const PerformanceMetricsComponent = (props) => {
  return (
    <div>
      <Row style={{ marginBottom: '15px' }}>
        <Col>
          <PerformanceTypeSelectorContainer />
        </Col>
      </Row>
      <Row>
        <Col sm={10} md={6} mdOffset={1}>
          <Row>
            {props.pageType === pageTypes.PERFORMANCEMETRICS &&
          (<MetricsSelectorContainer pageType={props.pageType} />) ||
        (<RegressionTestsPerformanceSelectorContainer pageType={props.pageType} />)}
          </Row>
          <Row>
            <ViewScenarioStatusContainer />
          </Row>
        </Col>
        <Col md={4}>
          <MetricsJobInfoContainer
            pageType={props.pageType}
          />
        </Col>
      </Row>
      <Row>
        <Col md={10} mdOffset={1}>
          <PerformanceDeltasContainer />
        </Col>
      </Row>
      <Row>
        <Col md={6} mdOffset={2}>
          <h2> Duration </h2>
          <PerformanceMetricsDurationChartContainer />
        </Col>
      </Row>
    </div>
  );
};

PerformanceMetricsComponent.propTypes = { pageType: PropTypes.object };
export default PerformanceMetricsComponent;


// WEBPACK FOOTER //
// src/Components/PerformanceMetricsComponent.jsx